import SubTitle from 'components/SubTitle';
import ImageSlider from 'components/ImageSlider';
import Title from 'components/Title';
import Layout from 'layout/Layout';
import styled from 'styled-components';
import Particles from 'react-tsparticles';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useEffect, useState } from 'react';
import moment from 'moment';
import themeInfoData from 'data/themeInfoData';
import { IThemeInfo } from 'scheme/themeInfo';
import ScrolledThemes from 'components/ScrolledThemes';
import PageHelmet from 'components/PageHelmet';
import Loading from 'react-loading';
import { theme } from 'styles/theme';
import { useParams } from 'react-router';
import { useSnackbar } from 'hooks/useSnackbar';
import Snackbar from 'components/Snackbar';
import { t } from 'i18next';
import { useSendToApp } from 'hooks/useSendToApp';
import { event } from 'react-ga';

const sliderSettings = {
  dots: false,
  dotsClass: 'slick-dots custom-dots',
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  centerMode: true,
};

export default function MainPage() {
  const themeInfo = themeInfoData.data;
  const [openedThemes, setOpenedThemes] = useState<IThemeInfo[]>([]);
  const [beforeOpenedThemes, setBeforeOpenedThemes] = useState<IThemeInfo[]>([]);
  const themeId = useParams<{ themeId?: string }>();
  const [now, setNow] = useState<moment.Moment>(moment().utc());
  const { isShowedUp, showSnackbar } = useSnackbar();
  const { isWebView } = useSendToApp();

  const Timer = () => {
    setInterval(() => {
      console.log(1);
      setNow(moment().utc());
    }, 5000);
  };

  useEffect(() => {
    Timer();
    return () => {
      clearInterval();
    };
  }, []);

  useEffect(() => {
    const currentTime = moment().utc();
    if (themeId.themeId) {
      setOpenedThemes(themeInfo.filter((theme) => theme.page === Number(themeId.themeId)));
      setBeforeOpenedThemes(themeInfo.filter((theme) => theme.page !== Number(themeId.themeId)));
      return;
    }

    if (currentTime.diff(themeInfo[themeInfo.length - 1].date, 'milliseconds') > 0) {
      setOpenedThemes(themeInfo);
      return;
    }

    themeInfo.map((themeInfo) => {
      if (currentTime.diff(themeInfo.date, 'milliseconds') > 0) {
        setOpenedThemes((prev) => [...prev, themeInfo]);
      } else {
        setBeforeOpenedThemes((prev) => [...prev, themeInfo]);
      }
    });
  }, []);

  useEffect(() => {
    setOpenedThemes((prev) => prev.reverse());
  }, []);

  const handleBeforeOpenedClick = () => {
    if (isWebView) return;
    showSnackbar();
  };

  const handleVisitClick = () => {
    event({
      category: 'click_snackbar_visit',
      action: 'Click snackbar visit',
    });

    window.open('https://share.plkey.app/start', '_blank');
  };
  return (
    <Layout>
      <PageHelmet />
      {openedThemes.length || beforeOpenedThemes.length ? (
        <>
          <ParticlesContainer>
            <Particles
              className="particles"
              options={{
                fullScreen: {
                  enable: true,
                  zIndex: 0,
                },
                particles: {
                  number: { value: 40, density: { enable: true, value_area: 600 } },
                  // color: { value: '#fff' },
                  shape: {
                    type: 'image',
                    // stroke: { width: 0, color: '#000000' },
                    // polygon: { nb_sides: 5 },
                    image: { src: require('assets/images/img_chocolate.png'), width: 0, height: 0 },
                  },
                  opacity: {
                    value: 1,
                    random: false,
                    anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false },
                  },
                  size: {
                    value: 15,
                    random: false,
                    // anim: { enable: false, speed: 40, size_min: 0.1, sync: false },
                  },
                  // line_linked: { enable: false, distance: 500, color: '#ffffff', opacity: 0.4, width: 2 },
                  move: {
                    enable: true,
                    speed: 1.5,
                    direction: 'bottom',
                    random: false,
                    straight: false,
                    out_mode: 'out',
                    bounce: false,
                    // attract: { enable: false, rotateX: 600, rotateY: 1200 },
                  },
                },
                interactivity: {
                  detect_on: 'window',
                  events: {
                    onhover: { enable: false, mode: 'bubble' },
                    onclick: { enable: false, mode: 'repulse' },
                    resize: true,
                  },
                  modes: {
                    grab: { distance: 400, line_linked: { opacity: 0.5 } },
                    bubble: { distance: 400, size: 4, duration: 0.3, opacity: 1 },
                    repulse: { distance: 200, duration: 0.4 },
                    push: { particles_nb: 4 },
                    remove: { particles_nb: 2 },
                  },
                },
                detectRetina: true,
              }}
            />
          </ParticlesContainer>
          <Title />
          <SubTitle />
          {screen.width <= 650 ? (
            <ImageSlider
              sliderSettings={sliderSettings}
              openedThemes={openedThemes}
              beforeOpenedThemes={beforeOpenedThemes}
              now={now}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          ) : (
            <ScrolledThemes
              openedThemes={openedThemes}
              beforeOpenedThemes={beforeOpenedThemes}
              now={now}
              handleBeforeOpenedClick={handleBeforeOpenedClick}
            />
          )}
        </>
      ) : (
        <LoadingContainer>
          <Loading color={theme.color.allMainColor} height="10%" width="10%" />
        </LoadingContainer>
      )}
      {isShowedUp && (
        <Snackbar content={t('visitApp')} confirm={t('visitAppConfirm')} closeSnackbar={handleVisitClick} />
      )}
    </Layout>
  );
}

const ParticlesContainer = styled.div`
  .particles {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    min-height: 100vh;
    z-index: 0;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
